import { useaxios } from "../../../utils/useaxios";
export default (sell_invoice_id, sell_invoice_type, sell_invoice_discount, sell_invoice_dollar_price, sell_invoice_loan_in_amount, customer_id, sell_invoice_customer_name, sell_invoice_customer_address, sell_invoice_customer_phone, items) => recaller => setrecaller => initDispatch => clear => printit => setsell_loading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/update.php', { sell_invoice_id, sell_invoice_type, sell_invoice_discount, sell_invoice_dollar_price, sell_invoice_loan_in_amount, customer_id, sell_invoice_customer_name, sell_invoice_customer_address, sell_invoice_customer_phone, items }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            setsell_loading(false);
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            // printit(res.invoiceno);
            setsell_loading(false);
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}